import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${rem(8)};
  margin-bottom: ${rem(32)};
  margin-top: ${rem(20)};
`

const FeatureContainer = styled(Group)`
  width: ${rem(148)};
`

function FirstTime() {
  const intl = useIntl()

  return (
    <Container>
      <Group direction="vertical" gap={20}>
        <BodyText variant="large" weight="bold">
          {intl.formatMessage({
            id: 'N/oW4KQKcL',
            defaultMessage: 'What are trips?',
            description: 'Heading introducing the trips feature to first-time users',
          })}
        </BodyText>
        <BodyText variant="large">
          {intl.formatMessage({
            id: 'kh15O1+kUY',
            defaultMessage: 'Trips are how you can group your saved offers. Your trip allows you to organise your favourite Luxury Escapes offers and easily plan your next adventure.',
            description: 'Description of the trips feature explaining how users can group and organise saved offers',
          })}
        </BodyText>
        <Group direction="vertical" tabletDirection="horizontal" gap={24}>
          <Group direction="horizontal" gap={24}>
            <FeatureContainer direction="vertical" gap={12}>
              <LineHeartIcon size="L" />
              <BodyText variant="medium">
                {intl.formatMessage({
                  id: 'xnnu+Mv58c',
                  defaultMessage: 'Save your favourite Luxury Escapes offers',
                  description: 'Feature description for saving favourite offers in trips',
                })}
              </BodyText>
            </FeatureContainer>
            <FeatureContainer direction="vertical" gap={12}>
              <LineMapIcon size="L" />
              <BodyText variant="medium">
                {intl.formatMessage({
                  id: 'cfFB2RoHU9',
                  defaultMessage: 'Map it out to visualise your itinerary',
                  description: 'Feature description for visualising trip itinerary on a map',
                })}
              </BodyText>
            </FeatureContainer>
          </Group>
          <Group direction="horizontal" gap={24}>
            <FeatureContainer direction="vertical" gap={12}>
              <LineRestaurantIcon size="L" />
              <BodyText variant="medium">
                {intl.formatMessage({
                  id: 'kU/mJdXEml',
                  defaultMessage: 'Discover top local attractions and sights',
                  description: 'Feature description for discovering local attractions in trips',
                })}
              </BodyText>
            </FeatureContainer>
            <FeatureContainer direction="vertical" gap={12}>
              <LinePlaneDepartureIcon size="L" />
              <BodyText variant="medium">
                {intl.formatMessage({
                  id: 'PvQ8SOxdJU',
                  defaultMessage: 'Book flights, hotels, car hire & more',
                  description: 'Feature description for booking travel services through trips',
                })}
              </BodyText>
            </FeatureContainer>
          </Group>
        </Group>
      </Group>
    </Container>
  )
}

export default FirstTime
